<template>
    <div class="header">
        <div class="header-cen clearfloat">
            <div class="head-left">
                <img src="../assets/header.png" class='logo2' alt="">
            </div>
            <div class="head-right">
                <router-link :to="item.href" :exact="item.href === '/'" active-class="active" :style="{'letter-spacing':item.name=='首页'?'0.3em':'0','text-indent':item.name=='首页'?'0.3em':'0'}" v-for="item in jumpList" :key="item.name" :href="item.href">
                    {{item.name}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
        jumpList: [
            {
                name: '首页',
                href: "/"
            },
            {
                name: '产品介绍',
                href: "/product"
            },
            {
                name: '产品价格',
                href: "/productPrice"
            },
            {
                name: '常见问题',
                href: "/scene"
            },
            {
                name: '关于我们',
                href: "/about"
            },
        ],
    }
  }
}
</script>
<style scoped>
    .header {
        height: 72px;
        background: #fff;
        overflow: hidden;
        position: sticky;
        top: 0;
        z-index: 1000; /* 确保导航栏在其他元素之上 */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影使其更加明显 */
    }
    .header-cen {
        margin: 0 auto;
        width: 1460px;
    }
    .head-left {
        float: left;
        color:#fff;
        height: 72px;
        line-height: 70px;
    }
    .logo{
        height: 40px;
        margin-right: 20px;
    }
    .line {
        width: 1px;
        height: 36px;
        background: #fff;
        margin-right: 25px;
    }

    .head-right {
        float: right;
        line-height: 72px;
        text-align: center;
    }
    .head-right a {
        color:#132053;
        font-size: 17px;
        display: inline-block;
        width: 106px;
        position: relative;
    }

    .head-right a:hover {
        font-weight: bold;
        color: #0954FF;
        position: relative;
    }
    .head-right a:hover::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, #FFFFFF 0%, #0569FF 100%);
        opacity: 0.2;
        pointer-events: none; /* 使背景不可点击 */
    }
    .head-right a:hover::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: 106px;
        height: 2px;
        background: #0954FF;
    }
    .header .active {
        font-weight: bold;
        color: #0954FF;
        position: relative;
    }

    /* 为了让文字不透明写的before */
    .header .active::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, #FFFFFF 0%, #0569FF 100%);
        opacity: 0.2;
        pointer-events: none; /* 使背景不可点击 */
    }

    .header .active::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: 106px;
        height: 2px;
        background: #0954FF;
    }

</style>


// WEBPACK FOOTER //
// src/components/headers.vue